import React, { useState, useEffect } from "react";
import { IAdvanceSearch } from "types";
import { useCustomerContext } from "contexts/Customer";
import "./style.scss";

type Props = {
	index: number;
  isAllowed: boolean;
  clear?: boolean;
};

export const AdvanceInput: React.FC<Props> = ({
	index,
  isAllowed,
  clear
}) => {
	const { searchFields, updateSearchFields } = useCustomerContext();
  const [val, setVal] = useState<string>(searchFields[index].value);

	useEffect(() => {
    if (clear) {
      setVal('');
    }
  }, [clear]);

  const onInputChange = (e: any) => {
    const inputVal = e.target.value;
    setVal(inputVal);
		searchFields.forEach((item) => {
			if(item.order == index) {
				item.value = inputVal;
			}
		})
		updateSearchFields(searchFields);
  };

  return (
    <div className="advance-input">
      <input
        value={val}
        type="text"
        disabled={!isAllowed}
        onChange={onInputChange}
      ></input>
    </div>
  );
};
